export const personName = (person) =>
  [person?.first_name, person?.last_name].filter(Boolean).join(' ') || '—';

export const influencerPublicName = (person) => {
  const fullName = person?.full_name?.trim();
  if (fullName) return fullName;

  return personName(person);
};

export const personInitials = (person) => {
  const name = personName(person);
  if (name === '—' && person?.email) {
    return person.email.slice(0, 2).toUpperCase();
  }
  return name
    .split(/\s+/)
    .map((w) => w[0])
    .join('')
    .slice(0, 2)
    .toUpperCase();
};

export const formatFollowers = (value) => {
  if (value === null || value === undefined || value === '') return '—';
  return String(value);
};
